import oAuthRequest from "./oauthRequest"


export const index = (search) => {
  return oAuthRequest.get('/api/v1/brands', { params: { search } })
}

export const markets = (brand_id) => {
  return oAuthRequest.get(`/api/v1/brands/${brand_id}/markets`)
}